<template>
  <div class="mb-5">
    <div
      v-if="isLoading"
      class="subheading"
    >
      <div class="text-xs-center pt-5">Please wait...</div>
    </div>
    <error-alert
      v-else-if="error"
      :error="error"
      class="mt-0"
    />
    <v-expansion-panel v-else>
      <v-expansion-panel-content
        v-for="entry in activity"
        :key="entry.ID"
      >
        <div slot="header">
          <v-layout>
            <v-flex xs6>{{ entry.action }}</v-flex>
            <v-flex
              xs6
              class="text-xs-right"
            >
              <span class="pr-3 grey--text text--darken-1">{{ entry.datetime | date }} {{ entry.datetime | date('time') }}</span>
            </v-flex>
          </v-layout>
        </div>
        <v-card>
          <v-card-text>
            <code style="width: 100%;">{{ entry }}</code>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </div>
</template>

<script>
  import ApiRequest from '@/services/ApiRequests/ApiRequestV2'
  import LogApi from '@/services/Api/LogApi'
  import Log, { PROJECT_NAMES } from '@/models/Log'
  import ErrorAlert from '@/components/ui/ErrorAlert.vue'

  export default {
    name: 'OpenBankingPaymentActivity',
    components: { ErrorAlert },
    props: {
      paymentId: {
        type: String,
        required: true
      }
    },
    data () {
      return {
        fetchActivityApiRequest: new ApiRequest(LogApi.fetchAll, Log)
      }
    },
    computed: {
      isLoading () {
        return this.fetchActivityApiRequest.loading
      },
      activity () {
        return this.fetchActivityApiRequest.data
      },
      error () {
        return this.fetchActivityApiRequest.error
      }
    },
    created () {
      this.fetchActivityApiRequest.execute({
        project_name: PROJECT_NAMES.OPEN_BANKING_INTEGRATION,
        paymentId: this.paymentId
      })
    }
  }
</script>
